module.exports = __webpack_public_path__ + "img/editor.597dc636.svg";